@if (label()) {
  <span
    class="inline-flex items-center justify-center px-2 py-0.5 h-5 rounded-full text-[11px] leading-[14px] font-normal {{
      badgeClasses()
    }}"
    >{{ label() }}</span
  >
}
